import React, {useEffect, useState} from "react";
import {
    gridFilteredDescendantCountLookupSelector,
    useGridApiContext,
    useGridSelector
} from "@mui/x-data-grid-pro";
import {
    EventAvailable,
    ExpandMore,
    FolderOpen,
    FolderSpecial,
    KeyboardArrowRight,
    PermMedia
} from "@mui/icons-material";
import {Box, Typography} from "@mui/material";

import {lightenColor} from "../../helpers/ColorUtils";
import {FOLDER_TYPE} from "../../domain/HierarchyConstants";

export default function ContentHierarchyGroupingCell(props) {

    const {id, field, row, rowNode, detailPanelExpandedRowIds, isUpdateComplete} = props;

    const [cellUpdated, setCellUpdated] = useState(false);
    const apiRef = useGridApiContext();
    const filteredDescendantCountLookup = useGridSelector(apiRef, gridFilteredDescendantCountLookupSelector);

    const filteredDescendantCount = filteredDescendantCountLookup[rowNode.id] ?? 0;
    const doesNodeHaveChildren = filteredDescendantCount > 0;
    const nodeStyle = {ml: rowNode.depth * 2, display: 'flex', alignItems: 'center', gap: 0.5};

    const handleClick = event => {
        if (rowNode.type !== "group") {
            return;
        }

        apiRef.current.setRowChildrenExpansion(id, !rowNode.childrenExpanded);
        apiRef.current.setCellFocus(id, field);

        if (rowNode.childrenExpanded) {
            detailPanelExpandedRowIds.current = detailPanelExpandedRowIds.current.filter((rowId) => rowId !== id);
        } else {
            detailPanelExpandedRowIds.current.push(id);
        }

        event.stopPropagation();
    }

    useEffect(() => {
        if (!cellUpdated) {
            setCellUpdated(true);
        }
    }, [cellUpdated]);

    useEffect(() => {
        if (detailPanelExpandedRowIds.current.length > 0 && isUpdateComplete.current) {
            let expandedIds = [...new Set(detailPanelExpandedRowIds.current)];
            expandedIds.forEach(id => {
                const currentNode = apiRef.current.getRowNode(id);
                if (currentNode && currentNode?.type !== "leaf") {
                    apiRef.current.setRowChildrenExpansion(id, true)
                }
            });
            isUpdateComplete.current = false;
        }
    }, [isUpdateComplete.current]);

    const Icon = row => {

        const margin = doesNodeHaveChildren ? 0 : '0.22rem';
        const mappedContentPlanColor = lightenColor(row.type.primaryColor);

        const iconMap = {
            [FOLDER_TYPE.SERVICE_TYPE]: <FolderSpecial sx={{color: row.type.primaryColor}} />,
            [FOLDER_TYPE.CONTENT_FOLDER]: <FolderOpen sx={{color: row.type.primaryColor}} />,
            [FOLDER_TYPE.CONTENT_INFO]: <PermMedia sx={{color: mappedContentPlanColor, ml: margin}} />,
            [FOLDER_TYPE.PUBLISHING_PLANS]: <EventAvailable sx={{color: mappedContentPlanColor, ml: '0.1rem'}} />,
        };

        return iconMap[row.type.folderType];
    }

    return (
      <Box onClick={handleClick} tabIndex={-1} sx={nodeStyle}>
          {doesNodeHaveChildren
            && (rowNode.childrenExpanded ? <ExpandMore/> : <KeyboardArrowRight/>)}
          <Icon type={row} />
          <Typography sx={{cursor: "pointer", fontSize: "14px"}}>{row.displayName}</Typography>
      </Box>
    );
}
